import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  Grid,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import bgImage from "../../assets/images/BG.svg";
import LoginForm from "./components/loginForm";
import Introduction from "@modules/register/components/introduction";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";

import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FooterCommonLogin from "@modules/public-comments/components/footerCommonLogin";
// import FooterCommonLogin from "@modules/register/components/footerCommonLogin";

const Login = () => {
  // FAQ items
  const faqs = [
    {
      q: "What types of NOCs can be applied for on RajMarg Pravesh?",
      a: "RajMarg Pravesh enables online submission and processing of Access and Right of Way (ROW) NOC applications related to National Highway assets."
    },
    {
      q: "How is the jurisdiction determined for my application?",
      a: "Jurisdiction is identified based on the chainage and location selected on the map during application submission."
    },
    {
      q: "What happens after I submit an application?",
      a: "The application is digitally scrutinized and routed to the concerned Authorities for review, inspection, and decision-making."
    },
    {
      q: "How do I respond if clarification is raised by an Authority?",
      a: "Clarifications must be submitted through the portal within the defined timeline, along with revised details or documents."
    },
    {
      q: "Will I be notified at every stage of processing?",
      a: "Yes, RajMarg Pravesh sends automated notifications for submission, clarification, inspection scheduling, and final decision."
    }
  ];
  return (
    <>
      <Box
        sx={{
          backgroundImage: `linear-gradient(rgba(15,23,42,0.55), rgba(15,23,42,0.10)), url(${require("@assets/images/common-login-bg.png")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: { xs: 520, md: 400 },
          display: "flex",
          alignItems: "center",
          py: { xs: 2, sm: 4, md: 6 }
        }}
      >
        <Container maxWidth="xl" sx={{ px: { xs: 1, sm: 2, md: 8 }, my:{ md: 4 } }}>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, md: 4 }}
            alignItems="center"
            direction={{ md: "row" }}
          >
            {/* Left content */}
            <Grid
              item
              xs={12}
              md={7}
              sx={{ mt: { xs: 0}, alignSelf: { xs: "flex-start" }, textAlign: { md: "left" } }}
            >
              <Typography
                variant="h3"
                sx={{
                  color: "#FFF",
                  fontWeight: 800,
                  fontSize: { xs: 22, sm: 28, md: 32 },
                  lineHeight: 1.2,
                  mb: 1.5
                }}
              >
                Welcome to the Rajmarg Pravesh Portal!
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#E2E8F0",
                  fontSize: { xs: 13, sm: 14, md: 14 },
                  fontWeight: 500,
                  maxWidth: { xs: "100%", md: 800, lg: 960 },
                  mx: { xs: "auto", md: 0 }
                }}
              >
                This portal enables submission and processing of No Objection
                Certificate (NOC) applications for Right of Way (ROW) and Access
                Permissions along National Highways, including fuel stations,
                wayside amenities, private properties, industrial and public
                utilities (OFC, pipelines, electrical wires, etc.). Applications
                are evaluated for safety, technical feasibility, legal
                compliance, and applicable fees.
              </Typography>
            </Grid>

            {/* Right login card */}
            <Grid item xs={12} md={5} sx={{ width: "100%", display: "flex", alignSelf: { xs: "flex-start" }, justifyContent: { xs: "center" }, mb: { xs: 2, md: 0 } }}>
              <Box sx={{ width: { xs: "100%"}, maxWidth: {xs: "100%", md: 400} }}>
                <LoginForm />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Contact Us */}
      <Box sx={{ bgcolor: "#F7F6FB" }}>
        <Container sx={{ py: { xs: 4, sm: 5, md: 8 } }}>
          <Typography
            sx={{
              textAlign: "center",
              fontWeight: 700,
              fontSize: { xs: 20, sm: 22, md: 24 },
              color: "#3A1C73",
              mb: 1
            }}
          >
            Contact Us
          </Typography>

          <Typography
            sx={{
              textAlign: "center",
              color: "#757575",
              fontSize: { xs: 14 },
              fontWeight: 400,
              maxWidth: { xs: "100%", md: 1024 },
              mx: "auto",
              mb: { xs: 3, sm: 4, md: 5 }
            }}>
            Get in touch with us for any queries regarding Access and Right of
            Way <br />
            Permissions along National Highways
          </Typography>

          <Grid container spacing={{ xs: 2, sm: 3}} justifyContent="center" width="100%">
            {[
              {
                icon: (
                  <EmailOutlinedIcon sx={{ color: "#212121", fontSize: { xs: 24, sm: 28 } }} />
                ),
                title: "Email Us",
                lines: ["support-rmp@gov.in"]
              },
              {
                icon: (
                  <AccessTimeOutlinedIcon
                    sx={{ color: "#3B1A77", fontSize: { xs: 24, sm: 28 } }}
                  />
                ),
                title: "Address",
                lines: [
                  "Transport Bhawan, 1 Parliament",
                  "Street New Delhi - 110001, India"
                ]
              }
            ].map(card => (
              <Grid item xs={12} sm={6} md={3.5} key={card.title} sx={{ display: "flex", justifyContent: "center" }}>
                <Card
                  variant="outlined"
                  sx={{
                    width: { xs: "100%"},  
                    height: "100%",
                    borderRadius: 3,
                    borderColor: "#E8E2D1",
                    px: { xs: 2, md: 3 },
                    py: { xs: 2, sm: 3, md: 4 },
                  }}
                >
                  <CardContent sx={{ textAlign: "center", p: 0 }}>
                    <Box
                      sx={{
                        display: "inline-flex",
                        width: 56,
                        height: 56,
                        borderRadius: 2,
                        bgcolor: "#F2EDF9",
                        border: "1px solid #E7DBFB",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 2
                      }}
                    >
                      {card.icon}
                    </Box>

                    <Typography
                      sx={{
                        fontFamily:
                          "Inter, system-ui, -apple-system, Segoe UI, Roboto, 'Helvetica Neue', Arial, sans-serif",
                        fontWeight: 700,
                        fontStyle: "normal",
                        fontSize: { xs: 15, sm: 16 },
                        lineHeight: "24px",
                        letterSpacing: "-0.005em",
                        textAlign: "center",
                        color: "#111827",
                        mb: 1
                      }}
                    >
                      {card.title}
                    </Typography>

                    <Stack spacing={0.5}>
                      {card.lines.map(t => (
                        <Typography
                          key={t}
                          component={t.includes("@") ? "a" : "p"}
                          href={t.includes("@") ? `mailto:${t}` : undefined}
                          sx={{
                            color: t.includes("@") ? "#6B7280" : "#6B7280",
                            fontSize: { xs: 13, sm: 14 },
                            fontWeight: 500,
                            textDecoration: "none",
                            wordBreak: "break-word",
                            "&:hover": t.includes("@")
                              ? { textDecoration: "underline" }
                              : undefined
                          }}
                        >
                          {t}
                        </Typography>
                      ))}
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
      {/* FAQ */}
      <Box sx={{ bgcolor: "#fff" }}>
        <Container sx={{ py: { xs: 4, sm: 5, md: 5 } }}>
          <Typography
            sx={{
              textAlign: "center",
              fontWeight: 700,
              fontSize: { xs: 18, sm: 20, md: 18 },
              color: "#3A1C73",
              mb: 0.5
            }}
          >
            Frequently Asked Questions
          </Typography>
          <Typography
            sx={{
              textAlign: "center",
              color: "#6B7280",
              fontSize: { xs: 13, sm: 14, md: 14 },
              fontWeight: 400,
              mb: { xs: 2, sm: 3, md: 4 }
            }}
          >
            Find answers to common questions
          </Typography>

          {faqs.map(faq => (
            <Accordion
              key={faq.q}
              disableGutters
              square
              sx={{
                boxShadow: "none",
                borderRadius: 0,
                "&:before": { display: "none" },
                borderBottom: "1px solid #E5E7EB",
                width: { xs: "100%", sm: "95%", md: "90%" },
                alignItems: "center",
                mx: "auto"
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#6B7280" }} />}
                sx={{
                  px: 0,
                  minHeight: { xs: 40, sm: 48 },
                  "& .MuiAccordionSummary-content": { my: 1 }
                }}
              >
                <Typography
                  sx={{ fontWeight: 500, fontSize: { xs: 13, sm: 14 }, color: "#212121" }}
                >
                  {faq.q}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 0, pb: { xs: 1, sm: 2 } }}>
                <Typography sx={{ fontSize: { xs: 13, sm: 14 }, color: "#6B7280" }}>
                  {faq.a}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Container>
      </Box>
      <FooterCommonLogin />
    </>
  );
};

export default Login;
